import  Phaser from 'phaser'

 export default  class Enemy1 extends Phaser.Physics.Arcade.Sprite

    


 {
    constructor (scene, x, y, texture, config)
    {
        super(scene, x, y, texture)
        this.scene = scene
        this.speed = config.speed
        
        
        this.look = 1 // 0 means left, 1 means right
        
    }
    
spawnRight(x) {
    

    
    this.setPosition(this.scene.scale.width + Phaser.Math.Between(0,20), 200)
    
    this.setActive(true)
    this.setVisible(true)
}

spawnLeft(x) {
  

    
    this.setPosition(0 - Phaser.Math.Between(0,20), 200)
    
    this.setActive(true)
    this.setVisible(true)
}


die() {
    this.destroy()
}

update(time) {
    
    
    this.setVelocityX(this.speed * 3)
    const gameHeight = this.scene.scale.height
    
    if (this.y > gameHeight + 5 ) {
        this.die()
    }
}

}